import * as yup from "yup";

export const PRACTICE_VALIDATION_SCHEMA = yup.object().shape({
  address: yup.string().required("Address is required"),
  general_email: yup.string().email("Enter a valid email address").required("Email is required"),
  name: yup.string().required("Practice Name is required"),
  office_manager_name: yup.string().required("Office Manager Name is required"),
  phone_number: yup
    .string()
    .matches(/^\d{10}$/, "Phone Number must be a valid US number")
    .required("Phone Number is required"),
  practice_type: yup.string().required("Practice Type is required"),
  status: yup.string().required("Status is required"),
});

export const PRACTICE_INITIAL_VALUES = {
  address: "",
  default_pcp_id: "",
  fax_number: "",
  general_email: "",
  intake_provider_ids: "",
  name: "",
  office_manager_name: "",
  phone_number: "",
  practice_type: "",
  status: "",
};

export const PRACTICE_SCHEMA = [
  {
    elementConfig: {
      label: "Practice Name",
      placeholder: "Practice Name",
      type: "text",
    },
    elementType: "input",
    name: "name",
  },
  {
    elementConfig: {
      label: "Practice Type",
      options: [
        { display: "Behavioral", value: "Behavioral" },
        { display: "Primary Care", value: "Primary Care" },
      ],
      placeholder: "",
    },
    elementType: "select",
    name: "practice_type",
  },
  {
    elementConfig: {
      label: "Phone Number",
      placeholder: "Phone Number",
      type: "text",
    },
    elementType: "input",
    name: "phone_number",
  },
  {
    elementConfig: {
      label: "Fax Number",
      placeholder: "Fax Number",
      type: "text",
    },
    elementType: "input",
    name: "fax_number",
  },
  {
    elementConfig: {
      label: "General Email Address",
      placeholder: "General Email Address",
      type: "text",
    },
    elementType: "input",
    name: "general_email",
  },
  {
    elementConfig: {
      label: "Office Manager Name",
      placeholder: "Office Manager Name",
      type: "text",
    },
    elementType: "input",
    name: "office_manager_name",
  },
  {
    displayName: "Address",
    elementType: "segment",
  },
  {
    elementConfig: {
      label: "Street",
      placeholder: "Enter Street",
      type: "text",
    },
    elementType: "input",
    name: "address.street",
  },
  {
    elementConfig: {
      label: "City",
      placeholder: "Enter City",
      type: "text",
    },
    elementType: "input",
    name: "address.city",
  },
  {
    elementConfig: {
      label: "State",
      placeholder: "Enter State",
      type: "text",
    },
    elementType: "input",
    name: "address.state",
  },
  {
    elementConfig: {
      label: "Zip",
      placeholder: "Enter zip",
      type: "text",
    },
    elementType: "input",
    name: "address.zip_code",
  },
  {
    elementConfig: {
      label: "Status",
      options: [
        { display: "Active", value: "active" },
        { display: "Inactive", value: "inactive" },
      ],
      placeholder: "",
    },
    elementType: "select",
    name: "status",
  },
  {
    elementConfig: {
      label: "Intake Coordinators",
      options: [],
      placeholder: "Intake Coordinators",
    },
    elementType: "react-select",
    name: "intake_provider_ids",
  },
  {
    elementConfig: {
      label: "Practice Specialization",
      options: [
        { display: "HCP", value: "HCP" },
        { display: "SPMI", value: "SPMI" },
        { display: "None", value: "None" },
      ],
      placeholder: "None",
      sentenceCase: false,
    },
    elementType: "select",
    name: "practice_specialization",
  },
  {
    elementConfig: {
      label: "Default PCP",
      options: [],
    },
    elementType: "select",
    name: "default_pcp_id",
  },
];
